import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import TextField from '@material-ui/core/TextField'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import FormControl from '@material-ui/core/FormControl'
import FormHelperText from '@material-ui/core/FormHelperText'

import SubmitButton from 'components/atoms/buttons/SubmitButton'

import { FORM_ACTION_ERROR_STATUS } from 'constants/form'

export const styles = theme => ({
  root: {
    width: 424,
    textAlign: 'center',
    padding: `0 ${theme.spacing(4)}px`,
  },
  errorMessage: {
    padding: `${theme.spacing(2)}px 0`,
  },
  formControl: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  submitButton: {
    marginTop: theme.spacing(2),
  },
  actions: {
    maxWidth: 360,
    display: 'flex',
    margin: '0 auto',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
})

const EditGroupForm = ({
  status,
  values,
  errors,
  classes,
  errorMessage,
  isSubmitting,
  hasFieldError,
  handleFormSubmit,
  handleFieldChange,
  handleGroupDeleteClick,
  className: classNameProp,
}) => {
  const className = classNames(classes.root, classNameProp)
  return (
    <div className={className}>
      <Typography variant="h1">Edit group</Typography>
      {status === FORM_ACTION_ERROR_STATUS && errorMessage ? (
        <Typography
          color="error"
          align="center"
          className={classes.errorMessage}>
          {errorMessage}
        </Typography>
      ) : null}
      <form noValidate autoComplete="off" onSubmit={handleFormSubmit}>
        <FormControl
          className={classes.formControl}
          fullWidth
          error={hasFieldError('name')}>
          <TextField
            type="name"
            name="name"
            id="name-input"
            margin="normal"
            label="Group name"
            autoComplete="name"
            value={values.name}
            onChange={handleFieldChange}
            error={hasFieldError('name')}
            inputProps={{
              maxLength: 1024,
            }}
          />
          {hasFieldError('name') ? (
            <FormHelperText>{errors.name}</FormHelperText>
          ) : null}
        </FormControl>
        <FormControl
          className={classNames(classes.formControl, classes.actions)}
          fullWidth>
          <SubmitButton
            autoFocus
            size="medium"
            color="primary"
            variant="secondary"
            disabled={isSubmitting}
            onClick={handleGroupDeleteClick}
            className={classes.submitButton}>
            Delete group
          </SubmitButton>
          <SubmitButton
            autoFocus
            size="medium"
            type="submit"
            color="primary"
            variant="primary"
            disabled={isSubmitting}
            className={classes.submitButton}>
            Update
          </SubmitButton>
        </FormControl>
      </form>
    </div>
  )
}

EditGroupForm.propTypes = {
  errors: PropTypes.object,
  status: PropTypes.string,
  values: PropTypes.object,
  className: PropTypes.string,
  isSubmitting: PropTypes.bool,
  hasFieldError: PropTypes.func,
  errorMessage: PropTypes.string,
  handleFormSubmit: PropTypes.func,
  handleFieldChange: PropTypes.func,
  classes: PropTypes.object.isRequired,
  handleGroupDeleteClick: PropTypes.func,
}

export default withStyles(styles)(EditGroupForm)



// WEBPACK FOOTER //
// ./src/components/organisms/EditGroupForm/EditGroupForm.js